<template>
    <a-modal v-model:open="open" :title="modalTitle" :width="680" :confirm-loading="confirmLoading" @ok="handleOk"
        @cancel="handleCancel">
        <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="商品编码" name="productCode">
                        <a-input v-model:value="formState.productCode" placeholder="如 VIP-30D-01" maxlength="50" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="商品名称" name="productName">
                        <a-input v-model:value="formState.productName" placeholder="如 专属会员-30天" maxlength="50" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="服务标识" name="serviceCode">
                        <a-select v-model:value="formState.serviceCode" placeholder="请选择服务标识"
                            :options="SERVICE_OPTIONS" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="计费模式" name="chargeMode">
                        <a-radio-group v-model:value="formState.chargeMode">
                            <a-radio value="COUNT">按次</a-radio>
                            <a-radio value="DURATION">按天</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col v-if="formState.chargeMode === 'COUNT'" :span="12">
                    <a-form-item label="包含次数" name="times">
                        <a-input-number v-model:value="formState.times" :min="1" :precision="0" style="width: 100%"
                            placeholder="必填，大于0" />
                    </a-form-item>
                </a-col>
                <a-col v-if="formState.chargeMode === 'DURATION'" :span="12">
                    <a-form-item label="会员天数" name="validDays">
                        <a-input-number v-model:value="formState.validDays" :min="1" :precision="0" style="width: 100%"
                            placeholder="必填，大于0" />
                    </a-form-item>
                </a-col>
                <a-col v-if="formState.chargeMode === 'COUNT'" :span="12">
                    <a-form-item label="有效期（天）" name="validDays">
                        <a-input-number v-model:value="formState.validDays" :min="1" :precision="0" style="width: 100%"
                            placeholder="选填，留空表示永久有效" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="折后价（元）" name="price">
                        <a-input-number v-model:value="formState.price" :min="0.01" :precision="2" style="width: 100%"
                            placeholder="必填，大于0" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="原价（元）" name="originalPrice">
                        <a-input-number v-model:value="formState.originalPrice" :min="0" :precision="2"
                            style="width: 100%" placeholder="选填，留空表示不区分会员" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="状态" name="status">
                        <a-radio-group v-model:value="formState.status">
                            <a-radio value="ON">上架</a-radio>
                            <a-radio value="OFF">下架</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="排序" name="sortNo">
                        <a-input-number v-model:value="formState.sortNo" :min="0" :precision="0" style="width: 100%" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="商品描述" name="description">
                        <a-textarea v-model:value="formState.description" :rows="3" maxlength="200"
                            placeholder="选填，小程序商品详情展示" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="赠送设置">
                        <a-switch v-model:checked="formState.giftEnabled" />
                        <span class="gift-tip">开启后可赠送其他服务次数，如买会员赠 5 次普通咨询</span>
                    </a-form-item>
                </a-col>
                <a-col v-if="formState.giftEnabled" :span="12">
                    <a-form-item label="赠送服务标识" name="giftServiceCode">
                        <a-select v-model:value="formState.giftServiceCode" placeholder="请选择赠送服务"
                            :options="SERVICE_OPTIONS" />
                    </a-form-item>
                </a-col>
                <a-col v-if="formState.giftEnabled" :span="12">
                    <a-form-item label="赠送次数" name="giftTimes">
                        <a-input-number v-model:value="formState.giftTimes" :min="1" :precision="0" style="width: 100%"
                            placeholder="必填，大于0" />
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
    </a-modal>
</template>

<script>
import { saveCommodity, updateCommodity } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref, reactive, computed, nextTick } from 'vue';

const SERVICE_OPTIONS = [
    { value: 'NORMAL_CONSULT', label: '普通咨询' },
    { value: 'MEMBER', label: '专属会员' },
];

// 金额换算：元 ↔ 分
const toFen = (yuan) => Math.round(Number(yuan) * 100);
const toYuan = (fen) => Number((Number(fen) / 100).toFixed(2));
// 未填写判定：null / undefined / 空串
const isEmptyValue = (value) => value === undefined || value === null || value === '';

export default {
    name: 'CommodityAddComponent',
    emits: ['saved'],
    setup(props, { emit }) {
        const open = ref(false);
        const confirmLoading = ref(false);
        const formRef = ref(null);
        const editId = ref(null);
        const formState = reactive({
            productCode: '',
            productName: '',
            serviceCode: undefined,
            description: '',
            chargeMode: 'COUNT',
            times: undefined,
            validDays: undefined,
            price: undefined,
            originalPrice: undefined,
            giftEnabled: false,
            giftServiceCode: undefined,
            giftTimes: undefined,
            status: 'ON',
            sortNo: 0,
        });

        const modalTitle = computed(() => (editId.value ? '编辑商品' : '新增商品'));

        // 数值校验：留空交给 required 规则，非空必须是大于 0 的整数
        const positiveIntValidator = (label) => (_rule, value) => {
            if (value === undefined || value === null || value === '') {
                return Promise.resolve();
            }
            const num = Number(value);
            if (!Number.isInteger(num) || num <= 0) {
                return Promise.reject(`${label}必须为大于0的整数`);
            }
            return Promise.resolve();
        };

        const priceValidator = (_rule, value) => {
            if (value === undefined || value === null || value === '') {
                return Promise.resolve();
            }
            if (Number(value) <= 0) {
                return Promise.reject('折后价必须大于0');
            }
            return Promise.resolve();
        };

        const originalPriceValidator = (_rule, value) => {
            if (value === undefined || value === null || value === '') {
                return Promise.resolve();
            }
            if (Number(value) < Number(formState.price || 0)) {
                return Promise.reject('原价不能低于折后价');
            }
            return Promise.resolve();
        };

        const rules = computed(() => ({
            productCode: [{ required: true, message: '请输入商品编码' }],
            productName: [{ required: true, message: '请输入商品名称' }],
            serviceCode: [{ required: true, message: '请选择服务标识' }],
            chargeMode: [{ required: true, message: '请选择计费模式' }],
            price: [
                { required: true, message: '请输入折后价' },
                { validator: priceValidator },
            ],
            originalPrice: [{ validator: originalPriceValidator }],
            times: formState.chargeMode === 'COUNT'
                ? [{ required: true, message: '请输入包含次数' }, { validator: positiveIntValidator('包含次数') }]
                : [],
            validDays: formState.chargeMode === 'DURATION'
                ? [{ required: true, message: '请输入会员天数' }, { validator: positiveIntValidator('会员天数') }]
                : [{ validator: positiveIntValidator('有效期') }],
            giftServiceCode: formState.giftEnabled ? [{ required: true, message: '请选择赠送服务标识' }] : [],
            giftTimes: formState.giftEnabled
                ? [{ required: true, message: '请输入赠送次数' }, { validator: positiveIntValidator('赠送次数') }]
                : [],
            status: [{ required: true, message: '请选择状态' }],
        }));

        const resetForm = () => {
            editId.value = null;
            Object.assign(formState, {
                productCode: '',
                productName: '',
                serviceCode: undefined,
                description: '',
                chargeMode: 'COUNT',
                times: undefined,
                validDays: undefined,
                price: undefined,
                originalPrice: undefined,
                giftEnabled: false,
                giftServiceCode: undefined,
                giftTimes: undefined,
                status: 'ON',
                sortNo: 0,
            });
        };

        const openModal = () => {
            open.value = true;
            // 弹窗渲染完成后清掉上一次的校验红字
            nextTick(() => formRef.value?.clearValidate());
        };

        const openAdd = () => {
            resetForm();
            openModal();
        };

        const openEdit = (record) => {
            resetForm();
            editId.value = record.id;
            formState.productCode = record.productCode || '';
            formState.productName = record.productName || '';
            formState.serviceCode = record.serviceCode;
            formState.description = record.description || '';
            formState.chargeMode = record.chargeMode || 'COUNT';
            // 后端把 0 与 null 都当作"未填"（如按天模式次数为 0、按次模式有效期为 0），回显统一按未填处理
            formState.times = record.times > 0 ? record.times : undefined;
            formState.validDays = record.validDays > 0 ? record.validDays : undefined;
            formState.price = record.price == null ? undefined : toYuan(record.price);
            // 原价 <= 0 在后端等价于"未配置"（订单按下单时回退折后价），回显统一按未填处理
            formState.originalPrice = record.originalPrice > 0 ? toYuan(record.originalPrice) : undefined;
            // 赠送字段成对出现才视为已开启
            formState.giftEnabled = !!(record.giftServiceCode && record.giftTimes);
            formState.giftServiceCode = record.giftServiceCode || undefined;
            formState.giftTimes = record.giftTimes ?? undefined;
            formState.status = record.status || 'ON';
            formState.sortNo = record.sortNo ?? 0;
            openModal();
        };

        const buildPayload = () => {
            const payload = {
                productCode: (formState.productCode || '').trim(),
                productName: (formState.productName || '').trim(),
                serviceCode: formState.serviceCode,
                description: formState.description || '',
                chargeMode: formState.chargeMode,
                price: toFen(formState.price),
                status: formState.status,
                sortNo: formState.sortNo ?? 0,
            };
            // 后端 updateById 忽略 null（清不掉旧原价），而原价<=0 在后端等价于"未配置"（订单回退折后价），
            // 因此留空时传 0，既能覆盖旧值，也不影响定价
            payload.originalPrice = isEmptyValue(formState.originalPrice) ? 0 : toFen(formState.originalPrice);
            if (formState.chargeMode === 'COUNT') {
                payload.times = formState.times;
                // 后端 updateById 忽略 null（清不掉旧值），而 validDays<=0 在后端等价于"永久有效"，
                // 因此留空时传 0，既表达"永久"，也能真正覆盖按天模式残留的有效期
                payload.validDays = isEmptyValue(formState.validDays) ? 0 : formState.validDays;
            } else {
                payload.validDays = formState.validDays;
                payload.times = 0;
            }
            if (formState.giftEnabled) {
                payload.giftServiceCode = formState.giftServiceCode;
                payload.giftTimes = formState.giftTimes;
            } else {
                // 同理：置空串（后端校验把空串视为"未填写"）才能清掉已配置的赠送标识
                payload.giftServiceCode = '';
            }
            if (editId.value) {
                payload.id = editId.value;
            }
            return payload;
        };

        const handleOk = async () => {
            try {
                await formRef.value?.validate();
            } catch {
                return;
            }
            confirmLoading.value = true;
            try {
                const isEdit = !!editId.value;
                const api = isEdit ? updateCommodity : saveCommodity;
                const response = await api(buildPayload());
                if (response.code === 200) {
                    message.success(response.msg || (isEdit ? '修改成功' : '添加成功'));
                    open.value = false;
                    emit('saved');
                } else {
                    // 展示后端校验文案，如"商品编码已存在"
                    message.error(response.msg || '操作失败');
                }
            } finally {
                confirmLoading.value = false;
            }
        };

        const handleCancel = () => {
            open.value = false;
        };

        return {
            SERVICE_OPTIONS,
            open,
            confirmLoading,
            formRef,
            formState,
            modalTitle,
            rules,
            openAdd,
            openEdit,
            handleOk,
            handleCancel,
        };
    },
};
</script>

<style scoped>
.gift-tip {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
}
</style>
